import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Alert } from 'react-bootstrap';
import BalancoService from '../../../../../services/balanco-auth';
import { Link, Navigate, useParams } from 'react-router-dom';



const FormFundo = () => {
    const [fundo, setFundo] = useState("");
    const [sucesso, setSucesso] = useState(false);
    const [error, setError] = useState([]);
    const { id } = useParams();

    async function fetchBalanco(id) {
        const response = await BalancoService.balancoEdit(id);
        setFundo(response.data["fundo"]);
    }

    useEffect(() => {
        fetchBalanco(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const balanco = await BalancoService.editar(id, {
                fundo: fundo
            })
            if (balanco.data["cod_balanco"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }
    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <div className="da-espaco">
                        <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                            <Row xs={1} lg={2}>
                                <Col>
                                    <Form.Group className="mb-3" controlId="fundo">
                                        <FloatingLabel
                                            label="Fundo do Balanço"
                                            className="mb-3"
                                        >
                                            <Form.Select
                                                required
                                                aria-label="fundo"
                                                name="fundo"
                                                onChange={e => setFundo(e.target.value)}
                                            >
                                                <option value={fundo}>{fundo}</option>
                                                <option value="Consolidado">Consolidado</option>
                                                <option value="Fundo Municipal de Assistência Social">Fundo Municipal de Assistência Social</option>
                                                <option value="Fundo Municipal de Habitação">Fundo Municipal de Habitação</option>
                                                <option value="Fundo Municipal de Meio Ambiente">Fundo Municipal de Meio Ambiente</option>
                                                <option value="Fundo Municipal de Saúde">Fundo Municipal de Saúde</option>
                                                <option value="Fundo Municipal de Educação">Fundo Municipal de Educação</option>
                                                <option value="Fundo Municipal dos Direitos da Criança e dos Adolescentes">Fundo Municipal dos Direitos da Criança e dos Adolescentes</option>
                                                <option value="Prefeitura Municipal">Prefeitura Municipal</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                                <Col xs={12} lg={2}>
                                    <Button type='submit' variant='primary'>Salvar</Button>
                                </Col>
                            </Row>

                        </Form>
                        <br />
                        <Link to={'/restrito/balanco/listar'}>
                            <Button variant="danger" type="button">
                                Cancelar
                            </Button>
                        </Link>
                    </div>
                </Container>
            </Fragment>
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Balanço editado com sucesso!</Alert>
                <Navigate to={'/restrito/balanco/listar'} />
            </Fragment>
        )
    }
}

export default FormFundo